module.exports = __webpack_public_path__ + "img/arrow_right_square.61057198.svg";